import React, { Fragment } from "react";
import { SwiperSlide } from "swiper/react";

import { Slider } from "../../../Slider";
import { MyCard } from "../../MyCard";

export default function EventsSlider({
  events,
  navigationNextRef,
  navigationPrevRef,
}) {
  const prefix = "event";

  return (
    <Fragment>
      <Slider
        navigationPrevRef={navigationPrevRef}
        navigationNextRef={navigationNextRef}
      >
        {events &&
          events.map((event, index) => {
            return (
              <SwiperSlide key={index} className="swiper-lazy">
                <MyCard prefix={prefix} event={event} />
              </SwiperSlide>
            );
          })}
      </Slider>
    </Fragment>
  );
}
